export default __webpack_public_path__ + "static/media/Identify-flow.209d6d6e.png";